import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import axiosApi from "../../utils/axios";

import {
  FailureCdrList,
  RequestCdrList,
  SuccessCdrList,
  RequestFsaCount,
  SuccessFsaCount,
  FailureFsaCount,
  RequestFsaAnalysisStatistics,
  SuccessFsaAnalysisStatistics,
  FailureFsaAnalysisStatistics,
  RequestAddApplication,
  SuccessAddApplication,
  FailureAddApplication,
  RequestFsaApplications,
  SuccessFsaApplications,
  FailureFsaApplications,
  RequestEditApplication,
  SuccessEditApplication,
  FailureEditApplication,
  RequestDeleteApplication,
  SuccessDeleteApplication,
  FailureDeleteApplication,
} from "../actions/fsaActions";

import { addNotification } from "../actions/notifierActions";

export function* cdrList({ payload }) {
  const { pageNumber, pageSize, filters = [] } = payload;
  const query = new URLSearchParams({
    pageNumber,
    pageSize,
    ...Object.fromEntries(filters.map((f) => [f.id, f.value])),
  });
  try {
    const response = yield call(axiosApi.get, `/api/fsa/list?${query.toString()}`);
    yield put(SuccessCdrList(response?.data || []));
  } catch (e) {
    yield put(FailureCdrList());
  }
}

export function* fsaCount({ payload: dailyOrTotal }) {
  try {
    const response = yield call(axiosApi.get, `/api/fsa/ui/count/${dailyOrTotal}`);
    yield put(SuccessFsaCount({ type: dailyOrTotal, count: response?.data || 0 }));
  } catch (e) {
    yield put(FailureFsaCount({ type: dailyOrTotal }));
  }
}

export function* fsaAnalysisStatistics() {
  try {
    const response = yield call(axiosApi.get, "/api/fsa/ui/analysis-statistics");
    yield put(
      SuccessFsaAnalysisStatistics({
        cleanAnalysisPct: response.data.clean_pct,
        suspiciousAnalysisPct: response.data.suspicious_pct,
        maliciousAnalysisPct: response.data.malicious_pct,
      }),
    );
  } catch (e) {
    yield put(FailureFsaAnalysisStatistics());
  }
}

export function* addApplication({ payload }) {
  try {
    const requestBody = { name: payload.name };
    if (payload.description !== undefined) {
      requestBody.description = payload.description;
    }
    yield call(axiosApi.post, "/api/fsa/applications", requestBody);
    yield put(SuccessAddApplication());
    yield call(fsaApplications);
    yield put(
      addNotification({
        message: "Added application successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureAddApplication());
    yield put(
      addNotification({
        message: e?.response?.data?.error || "Adding application failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* fsaApplications() {
  try {
    const response = yield call(axiosApi.get, "/api/fsa/applications");
    yield put(SuccessFsaApplications(response.data));
  } catch (e) {
    yield put(FailureFsaApplications());
  }
}

export function* fsaApplicationEdit({ payload }) {
  const { appId, field, value } = payload;
  try {
    const requestBody = { field };
    if (field === "description" && value !== undefined) {
      requestBody.value = value;
    }
    yield call(axiosApi.put, `/api/fsa/applications/${appId}`, requestBody);
    yield put(SuccessEditApplication());
    yield call(fsaApplications);
    yield put(
      addNotification({
        message: "Edited application successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureEditApplication());
    yield put(
      addNotification({
        message: e?.response?.data?.error || "Editing application failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* fsaApplicationDelete({ payload: deleteId }) {
  try {
    yield call(axiosApi.delete, `/api/fsa/applications/${deleteId}`);
    yield put(SuccessDeleteApplication());
    yield call(fsaApplications);
    yield put(
      addNotification({
        message: "Deleted application successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureDeleteApplication());
    yield put(
      addNotification({
        message: "Deleting application failed",
        options: { variant: "error" },
      }),
    );
  }
}

const fsaSagas = [
  takeEvery(RequestCdrList, cdrList),
  takeEvery(RequestFsaCount, fsaCount),
  takeLatest(RequestFsaAnalysisStatistics, fsaAnalysisStatistics),
  takeLatest(RequestAddApplication, addApplication),
  takeLatest(RequestFsaApplications, fsaApplications),
  takeLatest(RequestEditApplication, fsaApplicationEdit),
  takeLatest(RequestDeleteApplication, fsaApplicationDelete),
];

export default fsaSagas;
